import { render, staticRenderFns } from "./SetEmailOrPhone.vue?vue&type=template&id=54bf147c&scoped=true&"
import script from "./SetEmailOrPhone.vue?vue&type=script&lang=js&"
export * from "./SetEmailOrPhone.vue?vue&type=script&lang=js&"
import style0 from "./SetEmailOrPhone.vue?vue&type=style&index=0&id=54bf147c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf147c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/workspace/components/Card.vue').default})
